export const contentWriterFormConfig = [
    { label: "admin-panel-access", value: "adminPanelAccess" },
    { label: "editing-access", value: "editingAccess" },
];
